import React, { useState, useEffect } from "react";
import { StepProps } from "antd";
import Stepper from "../../Stepper";
import { IStepStatus } from "../../Stepper/interface";
import styles from "./PostOnboardingLayout.module.scss";
import LogoBlue from "../../../../../../assets/images/advancly-logo.png";

interface IPostOnboardingLayout {
  children?: React.ReactNode;
  bgColor?: string;
  onClose?: () => void;
  onBack?: () => void;
  showBackButton?: boolean;
  stepperList?: StepProps[];
  currentStep?: number;
  handleChange?: (step: number) => void;
}

const PostOnboardingLayout: React.FC<IPostOnboardingLayout> = ({
  children,
  bgColor = "background-white",
  onClose,
  onBack,
  showBackButton = false,
  stepperList = [],
  currentStep = 0,
  handleChange,
}) => {
  const [progress, setProgress] = useState(0);
  const [stepStatus] = useState<IStepStatus>("finish");
  const [highestStepReached, setHighestStepReached] = useState(0);

  // Track the highest step reached
  useEffect(() => {
    setHighestStepReached((prev) => Math.max(prev, currentStep));
  }, [currentStep]);

  useEffect(() => {
    // Calculate progress based on current step
    if (stepperList.length > 0 && currentStep !== undefined) {
      setProgress(((currentStep + 1) / stepperList.length) * 100);
    } else {
      setProgress(10);
    }
  }, [currentStep, stepperList]);

  return (
    <div className={`${styles.landingLayout} ${bgColor}`}>
      <div
        className={styles.onBoardingProgressBar}
        style={{ width: `${progress}%` }}
      ></div>
      <div className={styles.header}>
        <img
          className={styles.logoWhiteBgc}
          src={LogoBlue}
          alt="Advancly Logo"
        />
        {onClose && (
          <button
            onClick={onClose}
            className={styles.closeButton}
            aria-label="Close"
          >
            <i className="fa fa-times"></i>
          </button>
        )}
      </div>

      <main role="main" className={styles.main}>
        <div className={styles.left}>
          {showBackButton && onBack && (
            <button
              type="button"
              onClick={onBack}
              className={styles.backButton}
            >
              <i className="fas fa-chevron-left"></i> Go back
            </button>
          )}
          <div className={styles.content}>{children}</div>
        </div>
        <div className={styles.right}>
          <div className={styles.SliderContainer}>
            <div>
              <h2 className={styles.Title}>
                Next Steps to <span className={styles.Progress}>#Progress</span>
              </h2>
              <p className={styles.navigationExtraDetails}>
                Click a step below to navigate directly to that section
              </p>
              <div className={styles.StepperContainer}>
                <Stepper
                  items={stepperList}
                  status={stepStatus}
                  currentStep={currentStep}
                  onChange={handleChange}
                  direction="vertical"
                  size="default"
                  highestStepReached={highestStepReached}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PostOnboardingLayout;
